import { styleOverrides } from "./styleOverrides";

const MuiTableRow = {
  styleOverrides,
};

export { MuiTableRow };
